import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = 'Ignore', dodone, ignoreDodone, updateDodone }) => {
  if (!dodone || dodone.isIgnored || !dodone.isIgnorable) return null

  return (
    <div className="input-group">
      <ConfirmableSpinnableButton
        className="btn btn-danger btn-block"
        onConfirm={ignoreDodone}
        isSpinning={updateDodone.isPending}
        confirmation="Ignore?"
      >
        {text}
      </ConfirmableSpinnableButton>
    </div>
  )
}
